import { render, staticRenderFns } from "./ChimeDetailModal.vue?vue&type=template&id=16267919&scoped=true&"
import script from "./ChimeDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChimeDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChimeDetailModal.vue?vue&type=style&index=0&id=16267919&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16267919",
  null
  
)

export default component.exports